import { useContext } from 'react';
import { I18nContext, locales } from 'i18n';

export default function useLocale(): {
  localeCode: string;
  localeNativeName?: string;
} {
  const { locale } = useContext(I18nContext);
  const localeInfo = locales.find(({ lKey }) => lKey === locale);

  return {
    localeCode: locale,
    localeNativeName: localeInfo?.nativeName
  };
}
